import { Handle, Position } from "@xyflow/react";

const HANDLE_POSITIONS = [
  Position.Top,
  Position.Right,
  Position.Bottom,
  Position.Left,
];

/**
 * The four edge-connection handles shared by every connectable canvas node
 * (shapes, entities, text notes, text labels).
 *
 * These are plain React Flow `<Handle>`s — all visibility and styling lives in
 * canvas-styles.css, which hides handles globally and reveals them (on node
 * hover / while connecting) only for ones tagged `canvas-connect-handle`. The
 * component exists so the `${position}-source` ids — which the backend's
 * geometric edge routing emits (`bestEdgeHandles` in canvas_edit.go) — and the
 * marker class are defined once instead of drifting across node files.
 *
 * `connectionMode="loose"` on the ReactFlow root lets a single `source` handle
 * per side act as both the start and end of a connection.
 */
export function CanvasConnectHandles() {
  return (
    <>
      {HANDLE_POSITIONS.map((position) => (
        <Handle
          key={position}
          id={`${position}-source`}
          type="source"
          position={position}
          className="canvas-connect-handle"
        />
      ))}
    </>
  );
}
